import React from "react";
import Sequencing from "../../../components/Dashboard/Sequencing";
import "./style.scss";

const ViewGuidelinesPage = () => {
  return (
    <div className="view_guidelines_page">
      <Sequencing isViewOnly={true} />
    </div>
  );
};

export default ViewGuidelinesPage;
